import { useMemo, useState } from 'react';

import { useOptionalRequestInfo } from '@shared-web/request-info';

/**
 * SSR-safe authentication hook.
 *
 * Uses the requestInfo from root loader to get auth state.
 * This ensures SSR and client render the same content, preventing hydration mismatches.
 */
export function useAuth() {
  const requestInfo = useOptionalRequestInfo();

  // Use requestInfo value if available (SSR-safe), otherwise default to false
  const isLogin = requestInfo?.auth.isLoggedIn ?? false;

  const checkIsLogin = () => isLogin;
  const [isMasterAccount] = useState(true);
  const [isFCM] = useState(false);
  const [subAccountUuid] = useState('');
  const [isFCMAuthed] = useState(false);
  // const isFCM = useFCMContext()
  // const isFCMAuthed = useFCMAccount()
  // const subAccountUuid = useSubAccount()

  const isAuthed = useMemo(() => {
    if (!isFCM) {
      if (isMasterAccount) {
        return isLogin;
      }

      return !!subAccountUuid;
    }

    return isFCMAuthed;
  }, [isFCM, isFCMAuthed, subAccountUuid, isMasterAccount, isLogin]);

  return {
    isLogin,
    checkIsLogin,
    isAuthed,
  };
}
